import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, profile, profileLoading } = useAuth();
  const location = useLocation();


  // Still checking auth state or loading profile (profile===undefined means fetch hasn't resolved yet)
  if (user === undefined || profileLoading || profile === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-brand-red border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-gray-500 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if onboarding is needed -- but don't redirect if already on an onboarding page.
  // Gate on any name field being present, NOT onboarding_complete — mobile-created docs
  // never write that flag but do have full_name / display_name / name set.
  const isOnboardingRoute = location.pathname.startsWith('/onboarding') || location.pathname.startsWith('/dev-audit');
  const hasName = !!(profile?.first_name || profile?.full_name || profile?.display_name || profile?.name);
  const needsOnboarding = !profile || !hasName;
  if (!isOnboardingRoute && needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  // Authenticated and onboarded (or on onboarding route)
  return children;
};

export default ProtectedRoute;


